module.exports = __webpack_public_path__ + "static/media/nordigen-logo.6173e3ea.svg";